import {
  ACCOUNT_COMPLETE_TUTORIAL,
  ACCOUNT_COMPLETE_TUTORIAL_SUCCESS,
  ACCOUNT_CURRENT,
  ACCOUNT_CURRENT_SUCCESS,
  ACCOUNT_GET_INTEGRATIONS,
  ACCOUNT_GET_INTEGRATIONS_SUCCESS,
  ACCOUNT_PUT,
  ACCOUNT_PUT_SUCCESS,
  ACCOUNT_REQUEST,
  ACCOUNT_UPDATE,
  ACCOUNT_UPDATE_SUCCESS,
} from 'redux/constants/Accounts';

export const getAccount = (accountId) => {
  return {
    type: ACCOUNT_REQUEST,
    accountId,
  };
};

export const updateAccount = (accountId, data) => {
  return {
    type: ACCOUNT_UPDATE,
    accountId,
    data,
  };
};

export const putAccount = (accountId, data) => {
  return {
    type: ACCOUNT_PUT,
    accountId,
    data,
  };
};

export const updateAccountSuccess = (accountId, account) => {
  return {
    type: ACCOUNT_UPDATE_SUCCESS,
    account,
  };
};

export const putAccountSuccess = (accountId, account) => {
  return {
    type: ACCOUNT_PUT_SUCCESS,
    account,
  };
};

export const getCurrentAccount = () => ({
  type: ACCOUNT_CURRENT,
});

export const getCurrentAccountSuccess = (account) => ({
  type: ACCOUNT_CURRENT_SUCCESS,
  account,
});

export const completeTutorial = (id) => ({
  type: ACCOUNT_COMPLETE_TUTORIAL,
  id,
});

export const completeTutorialSuccess = () => ({
  type: ACCOUNT_COMPLETE_TUTORIAL_SUCCESS,
});

export const getIntegrations = (id) => ({
  type: ACCOUNT_GET_INTEGRATIONS,
  id,
});

export const getIntegrationsSuccess = (integrations) => ({
  type: ACCOUNT_GET_INTEGRATIONS_SUCCESS,
  integrations,
});
